import axios from 'axios';

$(function() {
    $('input[name=ship_from_island]').each((i, el) => {
        const $el = $(el);
        fetchShippingOptionsForIsland($el);
        $el.on('change', () => {
            fetchShippingOptionsForIsland($el);
        });
    });

    function fetchShippingOptionsForIsland($el) {
        if ($el.prop('checked')) {
            $('.shipping .shipping-methods').html(
                '\
                <div style="margin-top: 1rem;">\
                <img src="/img/ajax-loader.gif" />\
                <span>Fetching Shipping Options</span>\
                </div>\
            ',
            );
            axios
                .get('/checkout/shipping-options', {
                    params: { ship_from_island: $el.val() },
                })
                .then(({ data: view }) => {
                    $('.shipping .shipping-methods').html(view);
                    setupShippingProviders();
                })
                .catch(() => {
                    $('.shipping .shipping-methods').html(
                        '<span class="error">Something went wrong fetching your shipping options</span>',
                    );
                });
        }
    }

    function setupShippingProviders() {
        $('.shipping [data-shipping-provider]').each((i, el) => {
            const $el = $(el);
            setShippingProviderInputValue($el);
            $el.on('change', () => setShippingProviderInputValue($el));
        });
    }
    setupShippingProviders();

    function setShippingProviderInputValue($el) {
        console.log({ $el, isChecked: $el.is(':checked') });
        if ($el.is(':checked')) {
            const shippingProvider = $el.data('shipping-provider');
            $('.shipping input[name="shipping_provider"]').val(shippingProvider || '');
        }
    }
});
